import { useStoreActions, useStoreState } from 'easy-peasy'
import { useAsync } from 'react-use'
import _ from 'lodash'

import Select from 'components/Select'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function FilterDataTypeSelect({
  disabled = false,
  value = null,
  onChange = () => null,
}) {
  const { t } = useTranslate()

  const filterDataTypes = useStoreState((state) => state.filter.dataTypes)

  const getFilterDataTypes = useStoreActions((actions) => actions.filter.getDataTypes)

  const options = _.map(filterDataTypes, (filterDataType) => {
    return {
      label: filterDataType?.name,
      value: filterDataType?.id,
    }
  })

  useAsync(async () => {
    getFilterDataTypes()
  }, [])

  const selectProps = {
    defaultValue: value,
    disabled,
    options,
    placeholder: t('Data Type'),
    onChange,
  }

  return (
    <Styled className="filter-data-type-select-component">
      <Select {...selectProps} />
    </Styled>
  )
}
